import { render, staticRenderFns } from "./treeBlock.vue?vue&type=template&id=3497470e&"
import script from "./treeBlock.vue?vue&type=script&lang=js&"
export * from "./treeBlock.vue?vue&type=script&lang=js&"
import style0 from "./treeBlock.vue?vue&type=style&index=0&id=3497470e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports